// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M5 21Q4.18 21 3.59 20.41T3 19V5Q3 4.18 3.59 3.59T5 3H11Q11.42 3 11.71 3.29T12 4 11.71 4.71 11 5H5V19H19V13Q19 12.58 19.29 12.29T20 12 20.71 12.29 21 13V19Q21 19.82 20.41 20.41T19 21ZM19 6.4L10.4 15Q10.12 15.28 9.7 15.28T9 15 8.72 14.3 9 13.6L17.6 5H15Q14.58 5 14.29 4.71T14 4 14.29 3.29 15 3H20Q20.42 3 20.71 3.29T21 4V9Q21 9.42 20.71 9.71T20 10 19.29 9.71 19 9Z"/>';

/** External Link (actions). */
const icon: IconData = {
  id: "external-link",
  name: "External Link",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: {
      svg: '<path d="M3 21V3H12V5H5V19H19V12H21V21ZM9.7 15.7L8.3 14.3 17.6 5H14V3H21V10H19V6.4Z"/>',
    },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M5 21Q4.18 21 3.59 20.41T3 19V5Q3 4.18 3.59 3.59T5 3H11Q11.42 3 11.71 3.29T12 4 11.71 4.71 11 5H5V19H19V13Q19 12.58 19.29 12.29T20 12 20.71 12.29 21 13V19Q21 19.82 20.41 20.41T19 21ZM19 6.4L10.4 15Q10.12 15.28 9.7 15.28T9 15 8.72 14.3 9 13.6L17.6 5H15Q14.58 5 14.29 4.71T14 4 14.29 3.29 15 3H20Q20.42 3 20.71 3.29T21 4V9Q21 9.42 20.71 9.71T20 10 19.29 9.71 19 9Z"/></g><path d="M5 21Q4.18 21 3.59 20.41T3 19V5Q3 4.18 3.59 3.59T5 3H11Q11.42 3 11.71 3.29T12 4 11.71 4.71 11 5H5V19H19V13Q19 12.58 19.29 12.29T20 12 20.71 12.29 21 13V19Q21 19.82 20.41 20.41T19 21ZM19 6.4L10.4 15Q10.12 15.28 9.7 15.28T9 15 8.72 14.3 9 13.6L17.6 5H15Q14.58 5 14.29 4.71T14 4 14.29 3.29 15 3H20Q20.42 3 20.71 3.29T21 4V9Q21 9.42 20.71 9.71T20 10 19.29 9.71 19 9Z"/>',
    },
  },
  animation: () => import("../animations/external-link.js"),
};

export default icon;
